import { createApp } from "vue";
import App from "./App.vue";

const el = document.querySelector("#v4wp-app-vue");

let props = JSON.parse(el.dataset.props) ?? {};

console.log(`main.js Got props:`);
console.log(props);

createApp(App,{
    ...props
}).mount("#v4wp-app-vue");